<template>
  <div  id="app">
    <router-view/>
  </div>
</template>

<script>
// import { app } from '@/firebase'
// import { db } from '@/firebase'
// import bus from '@/bus.js'
export default {
  name: 'App',
  // data () {
  //   return {
  //     isReady: true
  //   }
  // },
  // created(){
  //   bus.$on('roomIdReady', data => {
  //     this.isReady = true
  //     alert('room is ready')
  //   })
  // }
}


</script>

<style>
html {
  touch-action: manipulation;
}

#app {
  /* font-family:  sans-serif; */
  font-family: 'Lato', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 10px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue